import { FC, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useTranslation } from 'react-i18next';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
}
export const IFramePage: FC<IProps> = ({ selectedRow, open = false, onClose }) => {
    const [reportTitle, setReportTilte] = useState(selectedRow ? selectedRow?.reportTitle : '');

    const [reportUri, setReportUri] = useState(selectedRow ? selectedRow?.reportUri : '');
    useEffect(() => {
        setReportTilte(selectedRow?.reportTitle === '-' ? ' ' : selectedRow?.reportTitle);
        setReportUri(selectedRow?.reportUri === '-' ? ' ' : selectedRow?.reportUri);
    }, [selectedRow]);

    const { t } = useTranslation();
    let url = 'https://studiotest.lcwaikiki.com/ssrs-gateway/ReportViewer?' + reportUri;
    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <DialogTitle>{reportTitle}</DialogTitle>
            <form>
                <DialogActions>
                    <CloseIcon onClick={onClose} className="svg_icons">
                        {t('general.cancel')}{' '}
                    </CloseIcon>
                </DialogActions>
                <div className="iframe-embed-wrapper iframe-embed-responsive-16by9">
                    <iframe
                        className="iframe-embed"
                        src={url}
                        //title needed for eslint warnings
                        title="Iframe-page"
                        style={{ border: '0' }}
                    ></iframe>
                </div>
            </form>
        </Dialog>
    );
};
